export const LiveClassScheduleType = {
  Today: 'today',
  Completed: 'completed',
  Upcoming: 'upcoming',
};
